export const routeNames = {
    home: '/',
};
